import { observer } from "mobx-react-lite";
import MainLayout from "../MainLayout";
import { useNavigate } from "react-router-dom";
import { VerticalLayout } from "../../common/common-layout";
import { TitleLargeMedium } from "../../common/common-text";
import { useEffect, useState } from "react";
import BTBox from "../../common/components/BTBox";
import CardList from "./CardList";
import { fetchPosts, deletePost } from "../../common/firebase/Firestore";
import Post from "../../model/archive/Post";
import { dialogStore } from '../../store/DialogStore';

const InternalGallery = () => {
    return (
        <MainLayout>
            <InternalGalleryBody />
        </MainLayout>
    );
};

export default InternalGallery;

const InternalGalleryBody = observer(() => {
    const boardName = 'intergallery'
    const navigate = useNavigate();
    const [posts, setPosts] = useState<Post[]>([]);

    useEffect(() => {
        async function loadData() {
            const posts = await fetchPosts(boardName);
            setPosts(posts);
        }

        loadData();
    }, []);

    // 페이징 상태 관리
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 18; // 한 페이지당 보여줄 카드 개수
    const totalPages = Math.ceil(posts.length / itemsPerPage);

    // 현재 페이지에 해당하는 데이터 슬라이싱
    const paginatedData = posts.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const handleDeleteClick = (selectedIndexes: number[]): void => {
        if (selectedIndexes.length === 0) {
            dialogStore.showDialog({
                title: '알림',
                message: '삭제할 항목을 선택하세요.',
                onConfirm: () => {},
            });
            return;
        }
    
        dialogStore.showDialog({
            title: '알림',
            message: '정말 삭제하시겠습니까?',
            onConfirm: async () => {
                try {
                    const selectedPostIds = selectedIndexes
                        .map(index => posts[index]?.id)
                        .filter((id): id is string => typeof id === 'string');
    
                    for (const id of selectedPostIds) {
                        await deletePost(boardName, id);
                    }
    
                    const updatedPosts = await fetchPosts(boardName);
                    setPosts(updatedPosts);
    
                    dialogStore.showDialog({
                        title: '성공',
                        message: '삭제가 완료되었습니다.',
                        onConfirm: () => {},
                    });
                } catch (error) {
                    console.error('삭제 오류:', error);
                    dialogStore.showDialog({
                        title: '오류',
                        message: '삭제 중 문제가 발생했습니다.',
                        onConfirm: () => {},
                    });
                }
            },
            onCancel: () => {
                console.log('삭제 취소');
            },
        });
    };

    const handleCardClick = (index: number): void => {
        navigate('/archive/intergallery/detail', { state: posts[index] })
    };

    return (
        <VerticalLayout height={'auto'} paddingLeft={36} paddingRight={36}>
            <TitleLargeMedium>사내전용 갤러리</TitleLargeMedium>
            <BTBox height="40px" />
            <CardList data={posts.map(d => ({
                id: d.id,
                title: d.title,
                imageSrc: d.representImage,
                displayDate: d.postDate,
            }))}
                handleCardClick={handleCardClick}
                onDeleteClick={handleDeleteClick}
                deleteButtonText="삭제"
                checkboxSelection={true}
            />
        </VerticalLayout>
    );
});
